import Instance from "../../../../Axios";

// New Actions for the app

const GetLastFichasTecnicas = () => async (dispatch) => {
  await Instance()
    .get(`/energias/fichasTecnicas/last/fichasTecnicas`)
    .then(({ data }) => {
      dispatch({ type: "GET_LAST_FICHAS_TECNICAS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetLastFichasTecnicas;
